import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { defineVuePlugin } from '#/vue-plugins'

export default defineVuePlugin((app) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        networkMode: 'always',
      },
      mutations: {
        networkMode: 'always',
      },
    },
  })
  app.use(VueQueryPlugin, { queryClient })
})
